/* Offre v5 Pinzelli : une ligne par pince avec menu déroulant en photos (façon Fincut). Sans dépendance.
   Ajout au panier (un seul clic, tout arrive en même temps, marqué « _pz_pack » = lot verrouillé dans le panier) :
   - une ligne par pince acétate (propriétés « Lot » et « _pz_pack ») ;
   - lot premium : les 2 Signatures choisies passent par un « Duo Signatures » (bundle natif Shopify à 17 €,
     composants = les vraies Signatures → stock décompté sur les vraies fiches) ;
   - la trousse offerte (fiche cachée à 0 €) pour le lot premium, la boîte offerte (fiche cachée à 0 €) pour chaque lot.
   Un seul lot Absolute (pzo-…) par commande : l'ancien est retiré avant d'ajouter le nouveau ;
   les packs Signatures / Magnéclip (pzs-…) ne sont pas touchés.
   Avec Kaching Cart, c'est Kaching qui ouvre son panier.
   Suivi (07/10/2026) : Shopify émet un événement « product_added_to_cart » PAR LIGNE ajoutée, repris tel quel
   par TrackBee (AddToCart Meta), Klaviyo (« Added to Cart »), Snapchat, Pinterest… → 7 événements pour un lot de 6.
   Désormais : les autres lignes et les cadeaux arrivent d'abord par un fetch « discret » (iframe cachée, non observé
   par les pixels), puis 1 seule ligne payante passe par l'ajout normal (= 1 événement). En cas de souci,
   retour automatique à l'ajout d'origine (tout en un). L'événement Klaviyo est envoyé par pz-cart-events.js (global). */
(function () {
  if (customElements.get('pz-offer')) return;
  var BOX_ID = 59504434282821;      /* boite-de-rangement-offerte (0 €) */
  var TROUSSE_ID = 59513798295877;  /* trousse-de-toilette-offerte-lot (0 €) */
  var ROSE_ID = 59582095065413;     /* pince-octobre-rose (0 €) : offerte avec le lot de 6 et le lot premium, Octobre Rose 2026 */
  var ROSE_END = Date.UTC(2026, 9, 31, 22, 59, 59); /* 31/10/2026 23:59:59 heure de Paris (UTC+1) : arrêt automatique */
  var PREM = { 59014890914117: 'G', 59014892683589: 'S', 59014895960389: 'O' };
  var DUO = { GG: 59513897189701, SS: 59513965609285, OO: 59513972883781, GS: 59513877922117, GO: 59513869566277, SO: 59513894338885 }; /* bundles Shopify Bundles (appli officielle) */
  function duoKey(a, b) { var order = 'GSO'; return [a, b].sort(function (x, y) { return order.indexOf(x) - order.indexOf(y); }).join(''); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function jsonFetch(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  /* fetch natif d'une iframe cachée (même origine) : ni Shopify Web Pixels ni les applis ne l'interceptent. */
  function quietFetch(path, body) {
    var f;
    try {
      f = document.createElement('iframe');
      f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.display = 'none'; f.src = 'about:blank';
      document.body.appendChild(f);
      var qf = f.contentWindow && f.contentWindow.fetch;
      if (typeof qf !== 'function') throw new Error('no quiet fetch');
    } catch (e) { if (f && f.parentNode) f.parentNode.removeChild(f); return Promise.reject(e); }
    var done = function () { setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 0); };
    return qf.call(f.contentWindow, location.origin + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { done(); if (j && j.status) throw j; return j; }, function (e) { done(); throw e; });
  }
  class PzOffer extends HTMLElement {
    connectedCallback() {
      try { this.opts = JSON.parse(this.querySelector('[data-options]').textContent); } catch (e) { return; }
      if (!this.opts.acet.length) return;
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      if (!this.tiers.length) return;
      this.cta = this.querySelector('[data-cta]');
      this.ctaLabel = this.cta.dataset.label || 'Ajouter au panier';
      this.premLabel = this.dataset.premiumLabel || '';
      var na = this.opts.acet.length, np = Math.max(this.opts.prem.length, 1), a = [], p = [];
      for (var i = 0; i < 12; i++) { a.push(i % na); p.push(i % np); }
      this.picks = { acet: a, prem: p };
      this.open = -1;
      this.addEventListener('click', this.onClick.bind(this));
      this.onDoc = this.onDoc.bind(this);
      document.addEventListener('click', this.onDoc);
      document.addEventListener('keydown', this.onDoc);
      this.select(this.tiers.find(function (t) { return t.classList.contains('is-selected'); }) || this.tiers[0]);
    }
    disconnectedCallback() { document.removeEventListener('click', this.onDoc); document.removeEventListener('keydown', this.onDoc); }
    get tier() { return this.tiers.find(function (t) { return t.classList.contains('is-selected'); }); }
    select(tier) {
      this.tiers.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        t.querySelector('[data-tier-btn]').setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.open = -1;
      this.render();
    }
    slots() {
      var t = this.tier, a = +t.dataset.acet, p = this.opts.prem.length ? +t.dataset.prem : 0, out = [];
      for (var i = 0; i < a; i++) out.push({ kind: 'acet', i: i });
      for (var j = 0; j < p; j++) out.push({ kind: 'prem', i: j });
      return out;
    }
    pick(slot) { var list = this.opts[slot.kind]; return this.picks[slot.kind][slot.i] % list.length; }
    item(slot) { return this.opts[slot.kind][this.pick(slot)]; }
    render() {
      var self = this;
      var rows = this.slots().map(function (s, n) {
        var it = self.item(s), isOpen = n === self.open, sel = self.pick(s);
        var tag = s.kind === 'prem' && self.premLabel ? '<span class="pzo__prem">' + esc(self.premLabel) + '</span>' : '';
        var menu = '';
        if (isOpen) {
          menu = '<div class="pzo__menu" role="listbox" aria-label="Couleur de la pince ' + (n + 1) + '">' + self.opts[s.kind].map(function (o, k) {
            return '<button type="button" role="option" aria-selected="' + (k === sel) + '" class="pzo__opt' + (k === sel ? ' is-on' : '') + '" data-row="' + n + '" data-opt="' + k + '"' + (o.ok ? '' : ' disabled') + '>' +
              '<img src="' + o.img + '" alt="" width="36" height="36"><span>' + esc(o.name) + '</span>' + (o.ok ? '' : '<small>Épuisé</small>') + '</button>';
          }).join('') + '</div>';
        }
        return '<div class="pzo__line' + (isOpen ? ' is-open' : '') + '"><span class="pzo__n">' + (n + 1) + '</span><div class="pzo__field">' +
          '<button type="button" class="pzo__dd" data-row="' + n + '" aria-haspopup="listbox" aria-expanded="' + isOpen + '">' +
          '<img src="' + it.img + '" alt="" width="36" height="36"><span class="pzo__dd-name">' + esc(it.name) + '</span>' + tag + '<span class="pzo__chev" aria-hidden="true"></span></button>' + menu + '</div></div>';
      }).join('');
      this.tiers.forEach(function (t) { if (t !== self.tier) t.querySelector('[data-picker]').innerHTML = '&#8203;'; });
      this.tier.querySelector('[data-picker]').innerHTML = rows;
      this.cta.textContent = this.ctaLabel + ' — ' + this.tier.dataset.price;
    }
    onDoc(e) {
      if (this.open < 0) return;
      if (e.type === 'keydown') { if (e.key === 'Escape') { this.open = -1; this.render(); } return; }
      if (e.composedPath().indexOf(this) === -1) { this.open = -1; this.render(); }
    }
    onClick(e) {
      var el = e.target.closest('[data-tier-btn],[data-opt],.pzo__dd,[data-cta]');
      if (!el) { if (this.open >= 0 && !e.target.closest('.pzo__menu')) { this.open = -1; this.render(); } return; }
      if (el.hasAttribute('data-tier-btn')) { if (el.closest('[data-tier]') !== this.tier) this.select(el.closest('[data-tier]')); return; }
      if (el.hasAttribute('data-opt')) {
        var s = this.slots()[+el.dataset.row];
        this.picks[s.kind][s.i] = +el.dataset.opt;
        this.open = -1;
        return this.render();
      }
      if (el.classList.contains('pzo__dd')) { var r = +el.dataset.row; this.open = this.open === r ? -1 : r; return this.render(); }
      if (el.hasAttribute('data-cta')) return this.add();
    }
    buildItems(label, pack) {
      var self = this, acet = {}, prem = [];
      this.slots().forEach(function (s) {
        var id = +self.item(s).id;
        if (s.kind === 'prem' && PREM[id]) prem.push(PREM[id]);
        else acet[id] = (acet[id] || 0) + 1;
      });
      var props = function (extra) { var p = { '_pz_pack': pack }; for (var k in extra) p[k] = extra[k]; return p; };
      var items = Object.keys(acet).map(function (id) { return { id: +id, quantity: acet[id], properties: props({ 'Lot': label }) }; });
      /* Signatures du lot premium → Duo (par paires) */
      for (var i = 0; i + 1 < prem.length; i += 2) {
        var duo = DUO[duoKey(prem[i], prem[i + 1])];
        if (!duo) throw new Error('Duo introuvable ' + prem[i] + prem[i + 1]);
        items.push({ id: duo, quantity: 1, properties: props({ 'Lot': label }) });
      }
      if (prem.length) items.push({ id: TROUSSE_ID, quantity: 1, properties: props({ 'Offert avec': label }) });
      var nAcet = 0; for (var k in acet) nAcet += acet[k];
      if (Date.now() <= ROSE_END && (nAcet >= 6 || prem.length)) items.push({ id: ROSE_ID, quantity: 1, properties: props({ 'Offert avec': label }) });
      if (BOX_ID) items.push({ id: BOX_ID, quantity: 1, properties: props({ 'Offert avec': label }) });
      return items;
    }
    add() {
      var self = this, label = this.tier.querySelector('.pzo__tier-name').textContent.trim(), pack = 'pzo-' + Date.now(), items;
      var errBox = self.querySelector('[data-error]'); errBox.hidden = true;
      try { items = this.buildItems(label, pack); } catch (e) { errBox.textContent = 'Oups, une erreur est survenue. Réessaie.'; errBox.hidden = false; console.warn('[pz-offer]', e); return; }
      var kaching = !!window.kachingCartApi, pinces = this.slots().length;
      var drawer = kaching ? null : document.querySelector('cart-drawer'), sec = {};
      if (drawer && drawer.getSectionsToRender) { sec.sections = drawer.getSectionsToRender().map(function (x) { return x.id || x.section; }); sec.sections_url = location.pathname; }
      var withSec = function (list) { var b = { items: list }; for (var k in sec) b[k] = sec[k]; return b; };
      var addUrl = (window.routes && window.routes.cart_add_url || '/cart/add') + '.js';
      /* Ligne « témoin » : la ligne payante la plus fournie → seul événement « ajout au panier » envoyé aux pixels. */
      var a = -1;
      items.forEach(function (it, i) { if (it.properties && it.properties.Lot && (a < 0 || it.quantity > items[a].quantity)) a = i; });
      var anchor = a >= 0 ? items[a] : null, rest = items.filter(function (it, i) { return i !== a; });
      var clearLot = function () {
        return jsonFetch('/cart.js').then(function (cart) {
          var up = {}, n = 0;
          (cart.items || []).forEach(function (l) { if (l.properties && String(l.properties._pz_pack || '').indexOf('pzo-') === 0) { up[l.key] = 0; n++; } });
          return n ? jsonFetch('/cart/update.js', { updates: up }) : null;
        }).catch(function () {});
      };
      var check = function (res) { if (res && res.status) throw new Error(res.description || res.message); return res; };
      /* Ordre : 1) le reste du lot (autres coloris + cadeaux) en discret ; 2) la ligne témoin par l'ajout normal → les pixels
         et Kaching voient UN ajout, et Kaching affiche directement le lot complet. La ligne témoin est envoyée avec « p » écrit
         \u0070 dans "pzo-" : même JSON pour Shopify, mais le script Kaching « nouveau lot = retire l'ancien » ne la prend pas
         pour un nouveau lot (sinon il retirerait le reste qu'on vient d'ajouter ; l'ancien lot est déjà retiré par clearLot). */
      var anchorBody = function () { return JSON.stringify(withSec([anchor])).split('"_pz_pack":"pzo-').join('"_pz_pack":"\\u0070zo-'); };
      window.pzLotHint = { pack: pack, label: label, pinces: pinces }; /* lu par pz-cart-events.js (événement Klaviyo unique) */
      this.cta.disabled = true; this.cta.textContent = 'Ajout…';
      clearLot().then(function () {
        if (!anchor || !rest.length) return jsonFetch(addUrl, withSec(items)).then(check);
        return quietFetch(addUrl, { items: rest }).then(function () {
          return fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: anchorBody() })
            .then(function (r) { return r.json(); })
            .then(check)
            .catch(function (e) { return clearLot().then(function () { throw e; }); });
        }, function (e) {
          if (e && e.status) return clearLot().then(function () { throw new Error(e.description || e.message); });
          console.warn('[pz-offer] ajout discret indisponible, ajout normal', e);
          return clearLot().then(function () { return jsonFetch(addUrl, withSec(items)); }).then(check);
        });
      }).then(function (res) {
        document.dispatchEvent(new CustomEvent('pz:cart-added', { detail: { pack: pack } }));
        if (kaching) {
          try { window.kachingCartApi.refreshCart && window.kachingCartApi.refreshCart(); window.kachingCartApi.openCart && window.kachingCartApi.openCart(); } catch (e) {}
          return;
        }
        try {
          if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); return; }
        } catch (e) { console.warn('[pz-offer] affichage du panier', e); }
        if (!window.pzCart) location.href = (window.routes && window.routes.cart_url) || '/cart';
      }).catch(function (err) {
        errBox.textContent = 'Oups, une erreur est survenue. Réessaie.'; errBox.hidden = false; console.warn('[pz-offer]', err);
      }).then(function () { self.cta.disabled = false; self.render(); });
    }
  }
  customElements.define('pz-offer', PzOffer);
})();
